export const PBMLaboratoryIcon: React.FC<React.SVGAttributes<{}>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="37"
    height="39"
    viewBox="0 0 37 39"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_18351_3226)">
      <path
        d="M14.5513 2.78822V12.0017C14.5513 12.9986 14.2696 13.9761 13.7377 14.8225L3.13507 31.6939C3.13507 31.6939 0.672069 35.3906 4.12455 37.2938C4.90795 37.7258 5.79533 37.9386 6.69217 37.9386H18.1809H19.3355H30.8243C31.7211 37.9386 32.6085 37.7258 33.3919 37.2938C36.845 35.39 34.3814 31.6939 34.3814 31.6939L23.7794 14.8225C23.2475 13.9761 22.9657 12.9992 22.9657 12.0017V2.78822"
        stroke="#197FDB"
        strokeWidth="1.78113"
        strokeMiterlimit="10"
      />
      <path
        d="M25.3491 0.25824H12.1662C11.3744 0.25824 10.7324 0.89404 10.7324 1.67834C10.7324 2.46264 11.3744 3.09844 12.1662 3.09844H25.3491C26.1409 3.09844 26.7829 2.46264 26.7829 1.67834C26.7829 0.89404 26.1409 0.25824 25.3491 0.25824Z"
        fill="#197FDB"
      />
      <path
        d="M29.6083 23.7484H7.90455L7.21191 25.9613H30.3066L29.6083 23.7484Z"
        fill="#197FDB"
      />
    </g>
    <defs>
      <clipPath id="clip0_18351_3226">
        <rect
          width="36.1011"
          height="39.2403"
          fill="white"
          transform="translate(0.708496 0.25769)"
        />
      </clipPath>
    </defs>
  </svg>
);
